var $g5Y9E$eyevinnvideoeventfilter = require("@eyevinn/video-event-filter");
var $g5Y9E$dailymotionvastclient = require("@dailymotion/vast-client");
var $g5Y9E$dailymotionvmap = require("@dailymotion/vmap");
var $g5Y9E$mitt = require("mitt");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "AdBreakTrackingEvent", () => $6a91d1a6b96ec270$export$8ee40f6ae4909ee9);
$parcel$export(module.exports, "AdTrackingEvent", () => $6a91d1a6b96ec270$export$af003d03c08e493d);
var $020ad56d15653aeb$exports = {};

$parcel$export($020ad56d15653aeb$exports, "CSAIManager", () => $020ad56d15653aeb$export$b74fc88014c397b3, (v) => $020ad56d15653aeb$export$b74fc88014c397b3 = v);
var $82676b94e7d3e1ec$exports = {};

$parcel$export($82676b94e7d3e1ec$exports, "AdServerService", () => $82676b94e7d3e1ec$export$3352be5704672342, (v) => $82676b94e7d3e1ec$export$3352be5704672342 = v);


var $6a91d1a6b96ec270$export$af003d03c08e493d;
(function($6a91d1a6b96ec270$export$af003d03c08e493d) {
    $6a91d1a6b96ec270$export$af003d03c08e493d["START"] = "start";
    $6a91d1a6b96ec270$export$af003d03c08e493d["IMPRESSION"] = "impression";
    $6a91d1a6b96ec270$export$af003d03c08e493d["EXPAND"] = "expand";
    $6a91d1a6b96ec270$export$af003d03c08e493d["MUTE"] = "mute";
    $6a91d1a6b96ec270$export$af003d03c08e493d["UNMUTE"] = "unmute";
    $6a91d1a6b96ec270$export$af003d03c08e493d["PAUSE"] = "pause";
    $6a91d1a6b96ec270$export$af003d03c08e493d["RESUME"] = "resume";
    $6a91d1a6b96ec270$export$af003d03c08e493d["REWIND"] = "rewind";
    $6a91d1a6b96ec270$export$af003d03c08e493d["CLOSE"] = "close";
    $6a91d1a6b96ec270$export$af003d03c08e493d["COMPLETE"] = "complete";
    $6a91d1a6b96ec270$export$af003d03c08e493d["FIRST_QUARTILE"] = "firstQuartile";
    $6a91d1a6b96ec270$export$af003d03c08e493d["MIDPOINT"] = "midpoint";
    $6a91d1a6b96ec270$export$af003d03c08e493d["THIRD_QUARTILE"] = "thirdQuartile";
    $6a91d1a6b96ec270$export$af003d03c08e493d["CLICK_THROUGH"] = "clickThrough";
    $6a91d1a6b96ec270$export$af003d03c08e493d["ERROR"] = "error";
})($6a91d1a6b96ec270$export$af003d03c08e493d || ($6a91d1a6b96ec270$export$af003d03c08e493d = {}));
var $6a91d1a6b96ec270$export$8ee40f6ae4909ee9;
(function($6a91d1a6b96ec270$export$8ee40f6ae4909ee9) {
    $6a91d1a6b96ec270$export$8ee40f6ae4909ee9["BREAK_START"] = "breakStart";
    $6a91d1a6b96ec270$export$8ee40f6ae4909ee9["BREAK_END"] = "breakEnd";
})($6a91d1a6b96ec270$export$8ee40f6ae4909ee9 || ($6a91d1a6b96ec270$export$8ee40f6ae4909ee9 = {}));
var $6a91d1a6b96ec270$export$f9cba49277c3a748;
(function($6a91d1a6b96ec270$export$f9cba49277c3a748) {
    $6a91d1a6b96ec270$export$f9cba49277c3a748["ClientSide"] = "csai";
    $6a91d1a6b96ec270$export$f9cba49277c3a748["ServerSide"] = "ssai";
})($6a91d1a6b96ec270$export$f9cba49277c3a748 || ($6a91d1a6b96ec270$export$f9cba49277c3a748 = {}));
var $6a91d1a6b96ec270$export$21ab339cd8e953dc;
(function($6a91d1a6b96ec270$export$21ab339cd8e953dc) {
    $6a91d1a6b96ec270$export$21ab339cd8e953dc["Preroll"] = "preroll";
    $6a91d1a6b96ec270$export$21ab339cd8e953dc["Midroll"] = "midroll";
    $6a91d1a6b96ec270$export$21ab339cd8e953dc["Postroll"] = "postroll";
})($6a91d1a6b96ec270$export$21ab339cd8e953dc || ($6a91d1a6b96ec270$export$21ab339cd8e953dc = {}));
var $6a91d1a6b96ec270$export$3d6415b1a42429de;
(function($6a91d1a6b96ec270$export$3d6415b1a42429de) {
    $6a91d1a6b96ec270$export$3d6415b1a42429de["NORMAL"] = "NORMAL";
    $6a91d1a6b96ec270$export$3d6415b1a42429de["SPONSOR"] = "BUMPER";
    $6a91d1a6b96ec270$export$3d6415b1a42429de["VIGNETTE"] = "VIGNETTE";
    $6a91d1a6b96ec270$export$3d6415b1a42429de["TRAILER"] = "TRAILER";
})($6a91d1a6b96ec270$export$3d6415b1a42429de || ($6a91d1a6b96ec270$export$3d6415b1a42429de = {}));
var $6a91d1a6b96ec270$export$66a223aa8aa4adc3 = {
    id: "unknown_advert",
    title: "",
    creative: {
        id: "unknown_creative",
        type: "?",
        mediafiles: [],
        trackingEvents: {}
    }
};


function $c2c23ffc2593fda7$export$7d60f72cc3d90ae5(dateString) {
    var p = dateString.split(":"), s = 0, m = 1;
    while(p.length > 0){
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
}
function $c2c23ffc2593fda7$export$ff9d762dbf7e2cc6(contentVideoElement) {
    var adVideoElement = document.createElement("video");
    adVideoElement.style.position = "absolute";
    adVideoElement.style.top = "0";
    adVideoElement.style.left = "0";
    adVideoElement.style.width = "100%";
    adVideoElement.style.height = "100%";
    adVideoElement.style.backgroundColor = "black";
    adVideoElement.style.display = "none";
    if (contentVideoElement) {
        adVideoElement.playsInline = contentVideoElement.playsInline;
        adVideoElement.muted = contentVideoElement.muted;
        adVideoElement.volume = contentVideoElement.volume;
    }
    return adVideoElement;
}


var $82676b94e7d3e1ec$var$__assign = undefined && undefined.__assign || function() {
    $82676b94e7d3e1ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82676b94e7d3e1ec$var$__assign.apply(this, arguments);
};
var $82676b94e7d3e1ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $82676b94e7d3e1ec$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $82676b94e7d3e1ec$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $82676b94e7d3e1ec$export$3352be5704672342 = /** @class */ function() {
    function $82676b94e7d3e1ec$export$3352be5704672342(debug) {
        if (debug === void 0) debug = false;
        this.debug = false;
        this.estimatedBandwidth = 500;
        this.debug = !!debug;
        this.vastParser = new $g5Y9E$dailymotionvastclient.VASTParser();
    }
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.getVMAP = function(url) {
        return $82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var vmapObject, adBreaks;
            return $82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.debug) console.debug("[CSAIManager] getVMAP", url);
                        return [
                            4 /*yield*/ ,
                            this.fetchAdsVMAP(url)
                        ];
                    case 1:
                        vmapObject = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.resolveAds(vmapObject)
                        ];
                    case 2:
                        adBreaks = _a.sent();
                        if (this.debug) console.debug("[CSAIManager] resolved VMAP to ad breaks", adBreaks);
                        return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.getVASTs = function(vastItems) {
        return $82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var adBreaks, _i, vastItems_1, vastItem, vastAdBreak, adBreakAds;
            return $82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.debug) console.debug("[CSAIManager] getVASTs", vastItems);
                        adBreaks = [];
                        _i = 0, vastItems_1 = vastItems;
                        _a.label = 1;
                    case 1:
                        if (!(_i < vastItems_1.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        vastItem = vastItems_1[_i];
                        return [
                            4 /*yield*/ ,
                            this.vastParser.getAndParseVAST(vastItem.vastUrl)
                        ];
                    case 2:
                        vastAdBreak = _a.sent();
                        if (!vastAdBreak) return [
                            2 /*return*/ 
                        ];
                        adBreakAds = vastAdBreak.ads;
                        adBreaks.push(this.mapAdBreakObject({
                            timeOffset: vastItem.timeOffset.toString()
                        }, adBreakAds));
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        if (this.debug) console.debug("[CSAIManager] resolved VAST to ad break", adBreaks);
                        return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.getVast = function(vastUrl) {
        return $82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var vastAdBreak, adBreakAds, adbreak;
            return $82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.debug) console.debug("[CSAIManager] get vast", vastUrl);
                        return [
                            4 /*yield*/ ,
                            this.vastParser.getAndParseVAST(vastUrl)
                        ];
                    case 1:
                        vastAdBreak = _a.sent();
                        if (!vastAdBreak) return [
                            2 /*return*/ 
                        ];
                        adBreakAds = vastAdBreak.ads;
                        adbreak = this.mapAdBreakObject({
                            timeOffset: "100"
                        }, adBreakAds);
                        if (this.debug) console.debug("[CSAIManager] resolved vast to ad break", adbreak);
                        return [
                            2 /*return*/ ,
                            adbreak
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.fetchAdsVMAP = function(u) {
        return $82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var response, xml, xmlParser, xmlDoc, vmapObject;
            return $82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(u)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        xml = _a.sent();
                        xmlParser = new DOMParser();
                        xmlDoc = xmlParser.parseFromString(xml, "text/xml");
                        vmapObject = new ($parcel$interopDefault($g5Y9E$dailymotionvmap))(xmlDoc);
                        return [
                            2 /*return*/ ,
                            vmapObject
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.resolveAds = function(vmapObject) {
        var _a;
        return $82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var adBreaks, _i, _b, adBreak, adsInBreak, adBreakAds, options;
            return $82676b94e7d3e1ec$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        adBreaks = [];
                        _i = 0, _b = vmapObject.adBreaks;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [
                            3 /*break*/ ,
                            5
                        ];
                        adBreak = _b[_i];
                        if (adBreak.breakType !== "linear") return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                        adsInBreak = (_a = adBreak.adSource) === null || _a === void 0 ? void 0 : _a.vastAdData;
                        adBreakAds = [];
                        if (!adsInBreak) return [
                            3 /*break*/ ,
                            3
                        ];
                        options = {
                            isRootVAST: true,
                            timeout: 10000,
                            withCredentials: true,
                            wrapperLimit: 10,
                            followAdditionalWrappers: true
                        };
                        this.vastParser.initParsingStatus(options);
                        return [
                            4 /*yield*/ ,
                            this.vastParser.parseVAST({
                                documentElement: adsInBreak
                            }, options)
                        ];
                    case 2:
                        adBreakAds = _c.sent().ads;
                        this.estimatedBandwidth = this.vastParser.getEstimatedBitrate();
                        _c.label = 3;
                    case 3:
                        adBreaks.push(this.mapAdBreakObject(adBreak, adBreakAds));
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapAdBreakObject = function(adBreak, ads) {
        var _this = this;
        var _a, _b, _c, _d;
        var adBreakObject = {
            insertionType: $6a91d1a6b96ec270$export$f9cba49277c3a748.ClientSide,
            breakType: adBreak.timeOffset === "start" || adBreak.timeOffset === "0" ? $6a91d1a6b96ec270$export$21ab339cd8e953dc.Preroll : $6a91d1a6b96ec270$export$21ab339cd8e953dc.Midroll,
            timeOffset: adBreak.timeOffset === "start" || adBreak.timeOffset === "0" ? 0 : $c2c23ffc2593fda7$export$7d60f72cc3d90ae5(adBreak.timeOffset),
            ads: ads === null || ads === void 0 ? void 0 : ads.map(function(ad) {
                return _this.mapAdsObject(ad);
            }).filter(function(ad) {
                return ad !== null;
            }),
            trackingEvents: {
                breakStart: ((_b = (_a = adBreak.trackingEvents) === null || _a === void 0 ? void 0 : _a.filter(function(abte) {
                    return abte.event === $6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_START;
                })) === null || _b === void 0 ? void 0 : _b.map(function(abte) {
                    return abte.uri;
                })) || [],
                breakEnd: ((_d = (_c = adBreak.trackingEvents) === null || _c === void 0 ? void 0 : _c.filter(function(abte) {
                    return abte.event === $6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_END;
                })) === null || _d === void 0 ? void 0 : _d.map(function(abte) {
                    return abte.uri;
                })) || []
            }
        };
        return adBreakObject;
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapAdsObject = function(ad) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var adServerExtension = ad.extensions.find(function(extension) {
            return extension.attributes.type === "AdServer";
        });
        var customAdId = ((_b = (_a = adServerExtension === null || adServerExtension === void 0 ? void 0 : adServerExtension.children.find(function(ext) {
            return ext.name === "AdInfo";
        })) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.customaid) || undefined;
        var variant = ((_d = (_c = adServerExtension === null || adServerExtension === void 0 ? void 0 : adServerExtension.children.find(function(ext) {
            return ext.name === "AdInfo";
        })) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.variant) || $6a91d1a6b96ec270$export$3d6415b1a42429de.NORMAL;
        var creative1 = this.findCreative(ad.creatives.map(function(creative) {
            return _this.mapCreativeObject(creative);
        }));
        if (!creative1) return null;
        var adObject = {
            id: ad.id,
            customAdId: customAdId,
            programmatic: customAdId === "PROGRAMMATIC",
            system: (_e = ad.system) === null || _e === void 0 ? void 0 : _e.value,
            sequence: ad.sequence,
            title: ad.title,
            variant: variant,
            creative: creative1,
            errorUrlTemplates: ad.errorURLTemplates,
            impressionUrlTemplates: ad.impressionURLTemplates.map(function(impressionUrlTemplate) {
                return impressionUrlTemplate.url;
            })
        };
        return adObject;
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.findCreative = function(creatives) {
        return creatives.find(function(creative) {
            return creative.type === "linear" && creative.mediafiles.length > 0;
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapCreativeObject = function(creative) {
        var _a;
        var _this = this;
        var creativeObject = {
            id: creative.id,
            adId: creative.adId,
            type: creative.type,
            duration: creative.duration,
            mediafiles: this.filterMediaFiles(creative.mediaFiles.map(function(mediaFile) {
                return _this.mapMediaFileObject(mediaFile);
            })),
            trackingEvents: $82676b94e7d3e1ec$var$__assign((_a = {}, _a[$6a91d1a6b96ec270$export$af003d03c08e493d.CLICK_THROUGH] = $82676b94e7d3e1ec$var$__spreadArray([], creative.videoClickTrackingURLTemplates, true), _a), creative.trackingEvents),
            clickThroughUrlTemplate: creative.videoClickThroughURLTemplate
        };
        return creativeObject;
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.filterMediaFiles = function(mediaFiles) {
        var _this = this;
        var playableMediaFiles = mediaFiles.filter(function(mediaFile) {
            return mediaFile.mimeType === "video/mp4";
        });
        var files = playableMediaFiles.filter(function(mediaFile) {
            return mediaFile.mimeType === "video/mp4" && mediaFile.fileUrl.length > 0 && (!mediaFile.bitrate || mediaFile.bitrate < _this.estimatedBandwidth);
        });
        // if no files are found, return the lowest one
        if (files.length === 0) files = playableMediaFiles;
        // otherwise return the filtered list top down
        return files.sort(function(a, b) {
            return a.bitrate && b.bitrate ? a.bitrate - b.bitrate : 0;
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapMediaFileObject = function(mediaFile) {
        var mediaFileObject = {
            id: mediaFile.id,
            mimeType: mediaFile.mimeType,
            fileUrl: mediaFile.fileURL,
            bitrate: mediaFile.bitrate,
            height: mediaFile.height,
            width: mediaFile.width
        };
        return mediaFileObject;
    };
    return $82676b94e7d3e1ec$export$3352be5704672342;
}();




var $cc312ea0fc7c8651$export$691d3e4b1045a188 = /** @class */ function() {
    function $cc312ea0fc7c8651$export$691d3e4b1045a188() {
        this.emitter = ($parcel$interopDefault($g5Y9E$mitt))();
    }
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.on = function(event, handler) {
        this.emitter.on.apply(this, [
            event,
            handler
        ]);
    };
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.off = function(event, handler) {
        if (this.emitter) this.emitter.off.apply(this, [
            event,
            handler
        ]);
    };
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.clear = function() {
        this.emitter.all.clear();
    };
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.emit = function(event, data) {
        if (this.emitter) this.emitter.emit.apply(this, [
            event,
            data
        ]);
    };
    return $cc312ea0fc7c8651$export$691d3e4b1045a188;
}();



function $e68d46ff2e90f1a5$export$d2858fcef9c76970(initOptions) {
    var _a;
    if (!initOptions.container && !initOptions.adVideoElement) {
        console.warn("[CSAIManager] container or adVideoElement is expected, choosing the parent of contentVideoElement as container");
        initOptions.container = initOptions.contentVideoElement.parentElement;
    }
    if (initOptions.container && initOptions.adVideoElement) {
        console.warn("[CSAIManager] either container or adVideoElement is expected, not both, choosing the adVideoElement");
        delete initOptions.container;
    }
    if (!initOptions.isLive && !initOptions.vmapUrl && !initOptions.adBreakVASTList) console.error("[CSAIManager] vmapUrl or adBreakVASTList is required");
    if (initOptions.vmapUrl && initOptions.adBreakVASTList) {
        console.warn("[CSAIManager] either vmapUrl or adBreakVASTList is expected, not both, choosing the adBreakVASTList");
        delete initOptions.vmapUrl;
    }
    if (initOptions.isLive && (initOptions.vmapUrl || ((_a = initOptions.adBreakVASTList) === null || _a === void 0 ? void 0 : _a.length) > 1)) console.warn("[CSAIManager] isLive is true, vmapUrl and adBreakVASTList are not expected, ignoring them");
    return initOptions;
}



var $020ad56d15653aeb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d1, b1) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d1, b1);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $020ad56d15653aeb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $020ad56d15653aeb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $020ad56d15653aeb$export$b74fc88014c397b3 = /** @class */ function(_super) {
    $020ad56d15653aeb$var$__extends($020ad56d15653aeb$export$b74fc88014c397b3, _super);
    function $020ad56d15653aeb$export$b74fc88014c397b3(initOptions) {
        var _this = _super.call(this) || this;
        _this.debug = false;
        _this.autoManagePlayback = true;
        _this.adBreaks = [];
        _this.adMarkers = [];
        _this.currentAdBreakVideos = [];
        _this.validCurrentTime = 0;
        _this.trackedAdBreaks = {};
        _this.trackedAds = {};
        _this.debug = !!initOptions.debug;
        _this.initOptions = initOptions;
        _this.state = "idle";
        _this.adServerService = new $82676b94e7d3e1ec$exports.AdServerService(_this.debug);
        initOptions = $e68d46ff2e90f1a5$export$d2858fcef9c76970(initOptions);
        if (_this.autoManagePlayback) initOptions.contentVideoElement.pause();
        _this.contentVideoElement = initOptions.contentVideoElement;
        _this.adVideoElement = _this.setupAdVideoElement(initOptions);
        _this.videoEventFilter = new $g5Y9E$eyevinnvideoeventfilter.VideoEventFilter(_this.adVideoElement);
        _this.autoManagePlayback = initOptions.autoManagePlayback ? initOptions.autoManagePlayback : true;
        _this.fetchAds(initOptions);
        return _this;
    }
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.setupAdVideoElement = function(initOptions) {
        if (initOptions.adVideoElement) return initOptions.adVideoElement;
        if (initOptions.container) {
            var adVideoElement = $c2c23ffc2593fda7$export$ff9d762dbf7e2cc6(this.contentVideoElement);
            initOptions.container.appendChild(adVideoElement);
            return adVideoElement;
        }
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.fetchAds = function(initOptions) {
        var _a;
        return $020ad56d15653aeb$var$__awaiter(this, void 0, Promise, function() {
            var _b, _c;
            return $020ad56d15653aeb$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (initOptions.isLive && ((_a = initOptions.adBreakVASTList) === null || _a === void 0 ? void 0 : _a.length) > 1) return [
                            2 /*return*/ 
                        ];
                        if (!initOptions.vmapUrl) return [
                            3 /*break*/ ,
                            2
                        ];
                        _b = this;
                        return [
                            4 /*yield*/ ,
                            this.adServerService.getVMAP(initOptions.vmapUrl)
                        ];
                    case 1:
                        _b.adBreaks = _d.sent();
                        _d.label = 2;
                    case 2:
                        if (!initOptions.adBreakVASTList) return [
                            3 /*break*/ ,
                            4
                        ];
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this.adServerService.getVASTs(initOptions.adBreakVASTList)
                        ];
                    case 3:
                        _c.adBreaks = _d.sent();
                        _d.label = 4;
                    case 4:
                        this.adBreaks = this.adBreaks.sort(function(a, b) {
                            return a.timeOffset - b.timeOffset;
                        });
                        this.adMarkers = this.adBreaks.map(function(adBreak) {
                            return adBreak.timeOffset;
                        });
                        this.start();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.play = function() {
        if (this.state !== "idle") return;
        this.state = "playing";
        this.playNextVideo();
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.fetchAdBreak = function(vastUrl) {
        return $020ad56d15653aeb$var$__awaiter(this, void 0, Promise, function() {
            var adBreak;
            return $020ad56d15653aeb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.adServerService.getVast(vastUrl)
                        ];
                    case 1:
                        adBreak = _a.sent();
                        if (adBreak) this.adBreaks.push(adBreak);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.triggerAdBreak = function() {
        return $020ad56d15653aeb$var$__awaiter(this, void 0, Promise, function() {
            return $020ad56d15653aeb$var$__generator(this, function(_a) {
                if (!this.adBreaks || this.adBreaks.length === 0) return [
                    2 /*return*/ 
                ];
                this.playAdBreak(this.adBreaks.shift());
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.start = function() {
        var _this = this;
        if (this.adMarkers[0] === 0) {
            this.adMarkers.shift();
            this.playAdBreak(this.adBreaks.shift());
        } else {
            var nextBreak = this.adMarkers.find(function(adMarker) {
                return adMarker > _this.contentVideoElement.currentTime;
            });
            if (!nextBreak) return;
            this.contentVideoElement.addEventListener("timeupdate", this.onContentTimeUpdateRef = this.onContentTimeUpdate.bind(this));
        }
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playAdBreak = function(adbreak) {
        if (this.autoManagePlayback) this.contentVideoElement.pause();
        this.currentAdBreak = adbreak;
        this.trackAdBreakEvent(this.currentAdBreak, $6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_START);
        for(var _i = 0, _a = adbreak.ads; _i < _a.length; _i++){
            var ad = _a[_i];
            this.currentAdBreakVideos.push(ad);
        }
        this.playNextVideo();
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playNextVideo = function() {
        this.videoEventFilter.clear();
        this.adVideoElement.removeEventListener("seeking", this.onAdSeekingRef);
        var ad = this.currentAdBreakVideos.shift();
        if (ad) this.playAd(ad);
        else this.playContent();
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playAd = function(ad) {
        var _this = this;
        var src = ad.creative.mediafiles[0].fileUrl;
        if (this.debug) console.debug("[CSAIManager] play ad", ad);
        if (!src) return this.playNextVideo();
        this.currentAd = ad;
        this.adVideoElement.style.display = "block";
        this.adVideoElement.src = src;
        if (this.state !== "idle" || this.initOptions.autoplay) this.adVideoElement.play();
        this.adVideoElement.addEventListener("playing", function() {
            _this.trackEvent($6a91d1a6b96ec270$export$af003d03c08e493d.START, _this.currentAd);
            _this.trackEvent($6a91d1a6b96ec270$export$af003d03c08e493d.IMPRESSION, _this.currentAd);
            _this.state = "playing";
        }, {
            once: true
        });
        this.adVideoElement.addEventListener("ended", function() {
            _this.trackEvent($6a91d1a6b96ec270$export$af003d03c08e493d.COMPLETE, _this.currentAd);
            _this.state = "ended";
            _this.validCurrentTime = 0;
            _this.playNextVideo();
        }, {
            once: true
        });
        this.videoEventFilter.addEventListener($g5Y9E$eyevinnvideoeventfilter.PlayerEvents.TimeUpdate, function() {
            if (!_this.adVideoElement.seeking) _this.validCurrentTime = _this.adVideoElement.currentTime;
            _this.monitorProgress();
        });
        this.videoEventFilter.addEventListener($g5Y9E$eyevinnvideoeventfilter.PlayerEvents.Pause, function() {
            _this.trackEvent($6a91d1a6b96ec270$export$af003d03c08e493d.PAUSE, _this.currentAd);
        });
        this.videoEventFilter.addEventListener($g5Y9E$eyevinnvideoeventfilter.PlayerEvents.Resume, function() {
            _this.trackEvent($6a91d1a6b96ec270$export$af003d03c08e493d.RESUME, _this.currentAd);
        });
        this.videoEventFilter.addEventListener($g5Y9E$eyevinnvideoeventfilter.PlayerEvents.Error, function() {
            _this.trackEvent($6a91d1a6b96ec270$export$af003d03c08e493d.ERROR, _this.currentAd);
        });
        // this has to be native to block seek properly
        this.adVideoElement.addEventListener("seeking", this.onAdSeekingRef = function() {
            var delta = _this.adVideoElement.currentTime - _this.validCurrentTime;
            if (Math.abs(delta) > 0.01) _this.adVideoElement.currentTime = _this.validCurrentTime;
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playContent = function() {
        var _this = this;
        if (this.debug) console.debug("[CSAIManager] play content");
        this.adVideoElement.style.display = "none";
        this.adVideoElement.src = "";
        if (this.currentAdBreak) {
            this.trackAdBreakEvent(this.currentAdBreak, $6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_END);
            this.currentAdBreak = null;
        }
        if (this.autoManagePlayback) this.contentVideoElement.play();
        var nextBreak = this.adMarkers.find(function(adMarker) {
            return adMarker > _this.contentVideoElement.currentTime;
        });
        if (!nextBreak) return;
        if (this.debug) console.debug("[CSAIManager] waiting for next break", nextBreak);
        this.contentVideoElement.addEventListener("timeupdate", this.onContentTimeUpdateRef = this.onContentTimeUpdate.bind(this));
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.onContentTimeUpdate = function() {
        var currentTime = this.contentVideoElement.currentTime;
        var nextBreak = this.adMarkers[0];
        if (currentTime > nextBreak) {
            this.contentVideoElement.removeEventListener("timeupdate", this.onContentTimeUpdateRef);
            this.adMarkers.shift();
            this.playAdBreak(this.adBreaks.shift());
        }
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.monitorProgress = function() {
        var _this = this;
        var currentTime = this.adVideoElement.currentTime;
        var duration = this.adVideoElement.duration;
        if (!this.currentAd) return;
        var remainingTime = duration - currentTime;
        var percentWatched = Math.round(100 - 100 * remainingTime / duration);
        var TrackingCuePoints = {
            25: $6a91d1a6b96ec270$export$af003d03c08e493d.FIRST_QUARTILE,
            50: $6a91d1a6b96ec270$export$af003d03c08e493d.MIDPOINT,
            75: $6a91d1a6b96ec270$export$af003d03c08e493d.THIRD_QUARTILE
        };
        Object.keys(TrackingCuePoints).map(function(value) {
            var event = TrackingCuePoints[value];
            if (percentWatched > parseInt(value, 10) && _this.currentAd) _this.trackEvent(event, _this.currentAd);
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.trackAdBreakEvent = function(adBreak, trackingEvent) {
        var _this = this;
        if (!adBreak || !adBreak.trackingEvents || !trackingEvent || this.trackedAdBreaks[adBreak.timeOffset] && this.trackedAdBreaks[adBreak.timeOffset][trackingEvent] === true) return;
        if (!this.trackedAdBreaks[adBreak.timeOffset]) this.trackedAdBreaks[adBreak.timeOffset] = {};
        this.emit(trackingEvent, adBreak);
        var trackingUrls = adBreak.trackingEvents[trackingEvent] || [];
        trackingUrls.forEach(function(url) {
            return $020ad56d15653aeb$var$__awaiter(_this, void 0, void 0, function() {
                return $020ad56d15653aeb$var$__generator(this, function(_a) {
                    if (this.debug) console.debug("[CSAIManager] ad break tracking event -> ".concat(trackingEvent), url);
                    new Image().src = url;
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        });
        this.trackedAdBreaks[adBreak.timeOffset][trackingEvent] = true;
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.trackEvent = function(trackingEvent, ad) {
        var _this = this;
        if (!ad || !trackingEvent || this.trackedAds[ad.id] && this.trackedAds[ad.id][trackingEvent] === true) return;
        if (!this.trackedAds[ad.id]) this.trackedAds[ad.id] = {};
        var trackingUrls = [];
        switch(trackingEvent){
            case $6a91d1a6b96ec270$export$af003d03c08e493d.IMPRESSION:
                trackingUrls = ad.impressionUrlTemplates || [];
                break;
            case $6a91d1a6b96ec270$export$af003d03c08e493d.ERROR:
                trackingUrls = ad.errorUrlTemplates || [];
                break;
            default:
                trackingUrls = ad.creative.trackingEvents[trackingEvent] || [];
                break;
        }
        this.emit(trackingEvent, ad);
        trackingUrls === null || trackingUrls === void 0 || trackingUrls.forEach(function(url) {
            return $020ad56d15653aeb$var$__awaiter(_this, void 0, void 0, function() {
                return $020ad56d15653aeb$var$__generator(this, function(_a) {
                    if (this.debug) console.debug("[CSAIManager] ad tracking event -> ".concat(trackingEvent), url);
                    new Image().src = url;
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        });
        this.trackedAds[ad.id][trackingEvent] = true;
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.destroy = function() {
        this.adBreaks = [];
        this.adMarkers = [];
        this.currentAd = null;
        this.currentAdBreak = null;
        this.currentAdBreakVideos = [];
        this.onContentTimeUpdateRef = null;
        this.onAdSeekingRef = null;
        this.trackedAdBreaks = {};
        this.trackedAds = {};
        this.videoEventFilter.clear();
        this.videoEventFilter.destroy();
        // if not sent in as a video element already in DOM, let's remove the created ad video element as well
        if (!this.initOptions.adVideoElement) this.adVideoElement.remove();
    };
    return $020ad56d15653aeb$export$b74fc88014c397b3;
}($cc312ea0fc7c8651$export$691d3e4b1045a188);



$parcel$exportWildcard(module.exports, $020ad56d15653aeb$exports);


//# sourceMappingURL=index.js.map
